import { useParams } from 'react-router';

import { StudioPageProps } from '../hooks/use-pro-studio-routes';
import { WithLoadingState } from '../router';
import { useProStudioCtxSelector } from '../xstate/app.xstate';
import { getChannelsFromPypes } from '../utils';
import { ChannelSettingsForm } from '../components';
import { DefaultFormValues } from '../components/channel-settings-form/channel-settings-form';

type ChannelSettingsPageProps = StudioPageProps;

const ChannelSettingsPage: React.FC<ChannelSettingsPageProps> = () => {
  const { channelId } = useParams();

  const { botPypes } = useProStudioCtxSelector((ctx) => ({
    botPypes: ctx.botPypes || [],
  }));

  // A Contact Center (vaapi) row shares its id with its stream and has no
  // widget settings — never resolve one into this form.
  const selectedChannel = getChannelsFromPypes(botPypes).find(
    ({ id, type }) => id === channelId && type !== 'vaapi'
  );

  const brandMomentUrl =
    selectedChannel?.beta?.customStyling?.brandMomentUrl || '';
  const customStyling = {
    ...(selectedChannel?.beta?.customStyling || {}),
    brandMomentUrl: brandMomentUrl,
  };

  const values: DefaultFormValues = {
    detailsFormValues: {
      name: selectedChannel?.name || '',
      env: selectedChannel?.env || 'sandbox',
      pypeId: selectedChannel?.pypeId || '',
      pypeName: selectedChannel?.parent || '',
      streamId: selectedChannel?.streamId || '',
      id: selectedChannel?.id || '',
    },
    brandingFormValues: {
      launcherName: selectedChannel?.beta?.customStyling?.launcherName || '',
      widgetStyleColor: selectedChannel?.style?.widgetStyleColor || '',
      widgetStyleTextColor: selectedChannel?.style?.widgetStyleTextColor || '',
      agentBubbleColor: selectedChannel?.style?.agentBubbleColor || '',
      agentBubbleTextColor: selectedChannel?.style?.agentBubbleTextColor || '',
      userBubbleColor: selectedChannel?.style?.userBubbleColor || '',
      userBubbleTextColor: selectedChannel?.style?.userBubbleTextColor || '',
      name: selectedChannel?.style?.name || 'Web Conversational Interface',
      bannerUrl: selectedChannel?.style?.bannerUrl || '',
      customPypeCss: selectedChannel?.customPypeCss || '',
      brandMomentUrl,
      buttonColor: customStyling.buttonColor || '#000000',
      textColor: customStyling.textColor || '#000000',
      logo: selectedChannel?.logo || '',
    },
    sizingFormValues: {
      widgetWidth: selectedChannel?.style?.widgetWidth || 0,
      widgetHeight: selectedChannel?.style?.widgetHeight || 0,
      shouldLockRatio: selectedChannel?.style?.shouldLockRatio || false,
    },
  };

  // The title is the channel's own name now, rendered by the form together with
  // the env badge, the Pype mark and the kebab it is renamed from (PSTUDIO-3768).
  return selectedChannel ? (
    <ChannelSettingsForm type="update" values={values} />
  ) : null;
};

export const ChannelSettings = WithLoadingState(ChannelSettingsPage);
